import { createHashHistory } from 'history';

export const AppHashHistory = createHashHistory();
